import styled from "styled-components"
import { mobile, tablet, mobilePortrait } from "../../Responsive"

export const Container = styled.div`
   position: fixed;
   top: ${(props) => props.positionY}px;
   left: 0;
   width: 100%;
   z-index: 900;
   min-height: 5vh;
`

export const Wrapper = styled.div`
   padding: 10px 20px;
   display: flex;
   align-items: center;
   justify-content: space-between;
   position: relative;
   top: ${(props) => props.positionY}px;

   ${mobile({ padding: "5px 10px" })}
`

export const Logo = styled.img`
   height: 120px;
   margin-left: auto;

   ${tablet({ height: "100px" })}
   ${mobile({ height: "100px" })}
   ${mobilePortrait({ height: "80px" })}
`
